import { RouteConfig } from 'vue-router'

const Share = () => import('../activity/bingo/Share.vue')

export const ShareRoute: RouteConfig = {
  path: '/bingo-share',
  name: 'bingo-share',
  component: Share,
  meta: {
    title: '天天跳绳',
  },
  props: (route) => ({ ...route.query }),
}

export default [ShareRoute]
